var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractTransferProtocolModal',_vm._g(_vm._b({attrs:{"strategy":_vm.strategy,"transferProtocol":_vm.transferProtocol}},'AbstractTransferProtocolModal',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }